import axiosInstance from "../lib/axiosInstance";

class ordersModel {
    constructor() {
        this.base_url = "/vendor_orders";
        this.base_url2 = "/reports/order";
        this.base_url3 = "/orders/gift";
    }
    async list(query = []) {
        return (
            await axiosInstance.get(`${this.base_url}?${new URLSearchParams(query)}`)
        ).data;
    }
    async create(data = []) {
        return await axiosInstance.post(this.base_url, data);
    }
    async update(id, data = []) {
        return await axiosInstance.post(`${this.base_url}/${id}?_method=PUT`, data);
    }
    async destroy(id, data = []) {
        return await axiosInstance.delete(`${this.base_url}/${id}`, data);
    }
    async show(id) {
        return (await axiosInstance.get(`${this.base_url}/${id}`)).data;
    }
    async ExportOrder(data = []) {
        return await axiosInstance.post(`${this.base_url2}`, data);
    }
    async pack(id, sub_order_id) {
        return await axiosInstance.post(
            `${this.base_url}/${id}/${sub_order_id}/pack`
        );
    }
    async return(id) {
        return await axiosInstance.post(`${this.base_url}/${id}/return`);
    }

  async email(id,sub_order_id) {
    return await axiosInstance.get(`${this.base_url}/${id}/${sub_order_id}/generate-docs/shiprocket`);
  }

  async packUpdate(id, sub_order_id) {
    return await axiosInstance.post(
      `${this.base_url}/${id}/${sub_order_id}/update`
    );
  }
  async invoiceUpdate(id, sub_order_id) {
    return await axiosInstance.post(
      `${this.base_url}/${id}/${sub_order_id}/invoice-update/shiprocket`
    );
  }

    async create(data = []) {
        return await axiosInstance.post(this.base_url, data);
    }
    async update(id, data = []) {
        return await axiosInstance.post(`${this.base_url}/${id}?_method=PUT`, data);
    }
    async destroy(id, data = []) {
        return await axiosInstance.delete(`${this.base_url}/${id}`, data);
    }
    async show(id) {
        return (await axiosInstance.get(`${this.base_url}/${id}`)).data;
    }
    async ExportOrder(data = []) {
        return await axiosInstance.post(`${this.base_url2}`, data);
    }
    async pack(id, sub_order_id, courier = "shreemaruti") {
        return await axiosInstance.post(
            `${this.base_url}/${id}/${sub_order_id}/pack/${courier}`
        );
    }

    async packUpdate(id, sub_order_id) {
        return await axiosInstance.post(`${this.base_url}/${id}/${sub_order_id}/update/shiprocket`);
    }
    async sendMail(id, sub_order_id) {
        return await axiosInstance.get(`${this.base_url}/${id}/${sub_order_id}/mail`);
    }
    async gift(data = []) {
        return await axiosInstance.post(this.base_url3, data);
    }
}

export default new ordersModel();
